import { getSdk, sdkReject } from "./sdk";
export const getContests = (query, surrogateKeys, opts) => {
    const sdk = getSdk(opts);
    surrogateKeys.add("aptivada");
    return sdk ? sdk.GetContests.queryAsPromise(query).then(response => response?.data?.aptivada?.apps) : sdkReject();
};
export const getContest = (query, surrogateKeys, opts) => {
    const sdk = getSdk(opts);
    surrogateKeys.add("aptivada");
    return sdk ? sdk.GetContest.queryAsPromise(query).then(response => response?.data?.aptivada?.app) : sdkReject();
};
//# sourceMappingURL=Aptivada.js.map